<script lang="ts">
  export let disabled: boolean = false;
  export let color: "primary" | "secondary" | "warn" = "primary";
  let className: string = "";
  export { className as class };
</script>

<button class="{className} {color}" class:disabled {...$$restProps} on:click>
  <slot />
</button>

<style lang="postcss">
  button {
    @apply bg-primary-indigo-blue rounded text-white px-5 py-2 border-0 font-medium;
  }

  button:hover {
    @apply bg-primary-indigo-blue;
    filter: brightness(0.9);
    box-shadow: 0px 2px 6px rgba(8, 185, 255, 0.2);
  }

  button.disabled {
    @apply bg-opacity-40;
    box-shadow: none;
    pointer-events: none;
  }

  /* button.primary.disabled {
    @apply bg-opacity-60;
  } */

  button.secondary {
    @apply bg-light-50 text-dark-50;
  }

  button.secondary:hover {
    background-color: #f0f0f0;
    box-shadow: none;
  }
</style>
